module.exports = __webpack_public_path__ + "img/kopsurat_jmc_footer.96756aff.png";